export default __webpack_public_path__ + "static/media/verificationOne.8b5324b1.png";